import { NavigateOptions, To, useNavigate } from 'react-router-dom';
import { markAppNavigationIntent } from '../utils/navigationAnimation';

export interface NavigationContextType {
    navigateTo: (to: To, options?: NavigateOptions) => void;
    goBack: () => void;
}

export const useNavigation = (): NavigationContextType => {
    const navigate = useNavigate();

    return {
        navigateTo: (to: To, options?: NavigateOptions) => {
            markAppNavigationIntent();
            navigate(to, options);
        },
        goBack: () => {
            markAppNavigationIntent();
            navigate(-1);
        },
    };
};
